// extracted by mini-css-extract-plugin
module.exports =  {"label":"Dq9F5ogZrXmAG20HGFsS","root":"xktZGG1yUd2FCFhi0Vul","value":"hZEAC0QshdIg1z6f3yBF"};